"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=14271%3A251))
 * @trackcomponent
 * @lastsynced 2026-09-30T17:16:17.000Z
 * @optimized using svgo:^3.3.4
 */
export const BSRFilter = createSVGIcon(
  <path
    d="M21 6.75a.75.75 0 0 0 0-1.5v1.5m0 6a.75.75 0 0 0 0-1.5v1.5m0 6a.75.75 0 0 0 0-1.5v1.5m-3-14a.75.75 0 0 0-1.5 0H18m-1.5 2.5a.75.75 0 0 0 1.5 0h-1.5m1.5 9.5a.75.75 0 0 0-1.5 0H18m-1.5 2.5a.75.75 0 0 0 1.5 0h-1.5m-9-8.5a.75.75 0 0 0-1.5 0h1.5M6 13.25a.75.75 0 0 0 1.5 0H6M21 6v-.75H3v1.5h18zM3 12v.75h18v-1.5H3zm18 6v-.75H3v1.5h18zM17.25 4.75h-.75v2.5H18v-2.5zm0 12h-.75v2.5H18v-2.5zm-10.5-6H6v2.5h1.5v-2.5z"
    fill="currentColor"
  />,
  "BSRFilter",
  (strictLocalize) => ({
    className: iconCls(),
    color: iconColor.primary,
    fill: "none",
    titleAccess: strictLocalize({
      id: "zjw4qG",
      defaultMessage: "Filter",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    viewBox: "0 0 24 24",
  })
);
